import { render, staticRenderFns } from "./txPairList.vue?vue&type=template&id=c4b70b1e&scoped=true&"
import script from "./txPairList.vue?vue&type=script&lang=js&"
export * from "./txPairList.vue?vue&type=script&lang=js&"
import style0 from "./txPairList.vue?vue&type=style&index=0&id=c4b70b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b70b1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4b70b1e')) {
      api.createRecord('c4b70b1e', component.options)
    } else {
      api.reload('c4b70b1e', component.options)
    }
    module.hot.accept("./txPairList.vue?vue&type=template&id=c4b70b1e&scoped=true&", function () {
      api.rerender('c4b70b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/market/txPairList.vue"
export default component.exports